import { Aplicacao } from '../../@types';

type AuditoriaObjeto = Record<string, unknown>;

function formatProductItem(value: unknown): string | null {
  if (typeof value === 'string') {
    return value;
  }

  if (typeof value === 'object' && value !== null) {
    const itemValue = value as Record<string, unknown>;

    try {
      return (
        (itemValue.descricao as string) ||
        (itemValue.nome as string) ||
        (itemValue.codigo as string) ||
        JSON.stringify(itemValue)
      );
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  return null;
}

function parseObjeto(objeto: unknown): AuditoriaObjeto {
  if (typeof objeto === 'string') {
    try {
      return JSON.parse(objeto) as AuditoriaObjeto;
    } catch (error) {
      console.error(error);
      return {};
    }
  }

  return (objeto as AuditoriaObjeto) || {};
}

function formatProductList(products: unknown[]): string | null {
  const parsed = products.map(formatProductItem).filter(Boolean).join(', ');
  return parsed || null;
}

export default function extractProdutosFromAplicacao(item: Aplicacao): string {
  const parsedObjeto = parseObjeto(item.auditoriaAplicacao.objeto);
  const produtosAuditoria = (parsedObjeto as { produtos?: unknown }).produtos;

  if (Array.isArray(produtosAuditoria)) {
    const result = formatProductList(produtosAuditoria);
    if (result) return result;
  }

  if (Array.isArray(item.produtos)) {
    const result = formatProductList(item.produtos);
    if (result) return result;
  }

  return '-';
}
